










































import { Prop, Component, Vue } from 'vue-property-decorator'
import { v4 } from 'uuid'
import {cloneDeep} from 'lodash'

@Component
export default class InputLister extends Vue {

    @Prop({ required: true }) readonly value!: []
    @Prop({ required: true }) readonly defaultValue!: []
    @Prop({ required: true }) readonly name!: string
    @Prop({ default: 1 }) readonly min: number
    @Prop({ default: 99 }) readonly max: number
    @Prop({ default: null }) readonly rules!: string
    @Prop({default: false}) readonly showIndex: boolean

    uuid: string = v4()

    internalValues: [] = []

    mounted(): void {
        this.internalValues = this.value

        while (this.internalValues.length > this.max) {
            this.remove(this.internalValues.length - 1)
        }

        while (this.internalValues.length < this.min) {
            this.add()
        }
    }

    onInput(index: number, inputValue, callback = null): void {
        let internalValue = inputValue

        if (callback) {
            internalValue = callback(inputValue, this.internalValues[index])
        }

        this.$set(this.internalValues, index, internalValue)
        this.$emit('input', this.internalValues)
    }

    add(): void {
        if (this.internalValues.length !== this.max) {
            const newValue = this.defaultValue instanceof Function ? this.defaultValue() : cloneDeep(this.defaultValue)
            this.$set(this.internalValues, this.internalValues.length, newValue)
        }

        this.$emit('input', this.internalValues)
    }

    remove(index): void {
        if (this.internalValues.length !== this.min) {
            this.internalValues.splice(index, 1)
        }

        this.$emit('input', this.internalValues)
    }

    itemId(itemKey: number): string {
        return 'input-lister-' + this.uuid + '-' + itemKey
    }

    get exceedsMinimal(): boolean {
        return this.internalValues.length > this.min
    }

    get componentClasses(): object {
        return {
            'input-lister': true,
            'input-lister--show-index': this.showIndex,
        }
    }
}
